import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

export default defineNuxtPlugin((nuxtApp) => {
    const onlyCountries = [
        "UA",
        "AT",
        "BE",
        "GB",
        "DE",
        "DK",
        "ES",
        "IT",
        "IL",
        "NL",
        "NO",
        "PL",
        "PT",
        "FR",
        "CH",
        "SE",
        "EE",
        "LV",
        "LT",
        "FI",
        "CZ",
        "SK",
        "HU",
        "SI",
        "HR",
        "BA",
        "RS",
        "ME",
        "MK",
        "AL",
        "GR",
        "BG",
        "RO",
        "MD",
        "AD",
        "MC",
        "LI",
        "SM",
        "VA",
        "IS",
        "MT",
        "CY",
        "TR",
        "CA",
        "US",
        "MX",
        "GT",
        "BZ",
        "HN",
        "SV",
        "NI",
        "CR",
        "PA",
        "CO",
        "VE",
        "GY",
        "SR",
        "EC",
        "PE",
        "BO",
        "BR",
        "PY",
        "CL",
        "AR",
        "AU",
        "AE",
    ];

    const globalOptions = {
        mode: "international",
        onlyCountries,
        ignoredCountries: ["RU"],
    };

    nuxtApp.vueApp.use(VueTelInput, globalOptions);
});
